export const DEFAULT_JOBS_COLUMN_WIDTHS: { [key: string]: number } = {
  'col-id': 250,
  'col-pickup-address': 250,
  'col-dropoff-address': 250,
  'col-time-window': 180,
  'col-contact': 140,
  'col-service-time': 100,
  'col-sla': 130,
  'col-account': 160,
  'col-vehicles': 140,
  'col-account-ext-id': 150,
  'col-labels': 120,
  'col-tags': 120,
  'col-skills': 120,
  'col-packages': 120,
  'col-leftover-reason': 200,
  'col-recurring': 150,
  'col-load-weight': 80,
  'col-load-volume': 80,
  'col-load-packages': 80,
  'col-load-value': 80,
  'col-load-pallets': 80,
  'col-load-spots': 80
};

export const DEFAULT_ROUTES_COLUMN_WIDTHS: { [key: string]: number } = {
  'col-name': 300,
  'col-route-id': 100,
  'col-status': 100,
  'col-agent': 140,
  'col-vehicle': 140,
  'col-time-window': 180,
  'col-duration': 100,
  'col-distance': 100,
  'col-jobs-count': 80,
  'col-activities-count': 90,
  'col-accounts': 130,
  'col-account-ext-id': 150,
  'col-picking-hour': 120,
  'col-carrier': 140,
  'col-skills': 120,
  'col-labels': 120,
  'col-income': 100,
  'col-value': 100,
  'col-load-weight': 80,
  'col-load-volume': 80,
  'col-load-packages': 80,
  'col-load-value': 80,
  'col-load-pallets': 80,
  'col-load-spots': 80,
  'col-capacity-weight': 120,
  'col-capacity-volume': 120,
  'col-capacity-pallets': 120,
  'col-actions': 20
};

export const DEFAULT_ROUTE_DRILLDOWN_COLUMN_WIDTHS: { [key: string]: number } = {
  'col-id': 260,
  'col-type': 120,
  'col-account': 160,
  'col-account-ext-id': 160,
  'col-contact': 140,
  'col-distance': 100,
  'col-time-window': 180,
  'col-eta': 100,
  'col-address': 250,
  'col-service-time': 100,
  'col-sla': 130,
  'col-load': 90,
  'col-load-weight': 90,
  'col-load-volume': 90,
  'col-load-value': 90,
  'col-load-pallets': 90,
  'col-load-spots': 90,
  'col-capacity': 120,
  'col-barcodes': 150,
  'col-labels': 120,
  'col-vehicles': 140,
  'col-recurring': 150
};

export const DEFAULT_RESOURCES_COLUMN_WIDTHS: { [key: string]: number } = {
  'col-id': 220,
  'col-agent': 140,
  'col-vehicle': 140,
  'col-logistic-vehicle': 160,
  'col-time-window': 180,
  'col-carrier': 140,
  'col-skills': 120,
  'col-labels': 120,
  'col-tags': 120,
  'col-routes-count': 80,
  'col-total-duration': 100,
  'col-load-weight': 80,
  'col-load-volume': 80,
  'col-load-packages': 80,
  'col-load-spots': 80,
  'col-load-pallets': 80,
  'col-load-value': 80,
  'col-capacity-weight': 120,
  'col-capacity-volume': 120,
  'col-capacity-pallets': 120,
  'col-actions': 20
};
